import { createSlice } from "@reduxjs/toolkit";

const initialSlice = {
  token: null,
  permissionGranted: null,
  notifications: [],
};

const notificationSlice = createSlice({
  name: "notification",
  initialState: initialSlice,
  reducers: {
    setToken: (state, action) => {
      state.permissionGranted = true;
      state.token = action.payload;
    },
    onPermissionDenied: (state) => {
      state.permissionGranted = false;
    },
    onNewNotification: (state, action) => {
      state.notifications.unshift(action.payload);
    },
    setNotifications: (state, action) => {
      state.notifications = [...action.payload];
    },
  },
});

export const {
  setToken,
  onPermissionDenied,
  onNewNotification,
  setNotifications,
} = notificationSlice.actions;

export default notificationSlice.reducer;
